import {
  ADP_LOGO,
  BAMBOO_LOGO,
  BIGIN_LOGO,
  BRAINTREE_LOGO,
  DOCSIGN_LOGO,
  FRESHBOOKS_LOGO,
  FRESHSALES_LOGO,
  HUBSPOT_LOGO,
  NAMELY_LOGO,
  NETSUITE_LOGO,
  PIPEDRIVE_LOGO,
  QUICKBOOK_LOGO,
  SAGEINTACCT_LOGO,
  SF_LOGO,
  SLACK_LOGO,
  STRIPE_LOGO,
  XERO_LOGO,
  ZAPIER_LOGO,
  ZENDESK_LOGO,
  ZOHO_LOGO,
} from "./images";

import { FEATURES_NAME } from "./features";
import { TRIAL_AND_TRIAL_EXPIRED_PLANS } from "./billing";

export const SETTINGS_ACCOUNT = "account";
export const SETTINGS_SIGNATURE = "signature";
export const SETTINGS_BILLING = "billing";
export const SETTINGS_PROFILE = "profile";
export const SETTINGS_TEAMMATES = "teammates";
export const SETTINGS_ROLES = "roles";
export const SETTINGS_INTEGRATIONS = "integrations";
export const SETTINGS_AUTHENTICATION = "authentication";
export const SETTINGS_REVV_OAUTH = "revv-api";
export const SETTINGS_BULK_AUTO_SIGNERS = "bulk-auto-signers";
export const DOCSIGN_LOGO_INFO = DOCSIGN_LOGO;
export const SETTINGS_BLOCKCHAIN = "blockchain";

// Billing Plan Types
export const FREE_TRAIL = "essentials";
export const ENTERPRISE = ["enterprise-monthly", "enterprise-annual"];

const SETTINGS = {
  MANAGE_COMPANY_SETTINGS: "manage_company_settings",
  MANAGE_TEAMMATES: "manage_teammates",
  MANAGE_ROLES: "manage_roles",
  CONFIGURE_INTEGRATIONS: "read_integrations",
  MANAGE_AUTHENTICATIONS: "manage_authentications",
};

export const SETTINGS_VIEWS = [
  {
    name: "Profile settings",
    settingsView: SETTINGS_PROFILE,
    fullpath: "/settings/profile",
    faStyle: "far",
    faIcon: "user-ninja",
    showOption: true,
    allowedInFreePlans: true,
  },
  {
    name: "Account settings",
    settingsView: SETTINGS_ACCOUNT,
    fullpath: "/settings/account",
    faStyle: "far",
    faIcon: "building",
    readPermission: SETTINGS.MANAGE_COMPANY_SETTINGS,
    showOption: true,
    allowedInFreePlans: false,
  },
  // {
  //   name: "Billing",
  //   settingsView: SETTINGS_BILLING,
  //   fullpath: "/settings/billing",
  //   faStyle: "far",
  //   faIcon: "badge-dollar",
  //   showOption: true,
  // },
  // {
  //   name: "Users",
  //   settingsView: SETTINGS_TEAMMATES,
  //   fullpath: "/settings/teammates",
  //   faStyle: "far",
  //   faIcon: "users",
  //   readPermission: SETTINGS.MANAGE_TEAMMATES,
  //   showOption: true,
  // },
  {
    name: "Signature settings",
    settingsView: SETTINGS_SIGNATURE,
    fullpath: "/settings/signature",
    faStyle: "far",
    faIcon: "signature",
    readPermission: SETTINGS.MANAGE_COMPANY_SETTINGS,
    showOption() {
      const appFlag = localStorage.getItem("appFlag")
        ? JSON.parse(localStorage.getItem("appFlag"))
        : undefined;

      // disable signature setting for non revv esign
      if (appFlag && appFlag.esign_type && appFlag.esign_type !== "REVV") {
        return false;
      }

      // check if user is admin
      const CURRENT_USER = localStorage.getItem("revvsalesUser")
        ? JSON.parse(localStorage.getItem("revvsalesUser"))
        : undefined;
      if (
        CURRENT_USER &&
        CURRENT_USER.roles &&
        CURRENT_USER.roles.length > 0 &&
        CURRENT_USER.roles[0].name === "Admin"
      ) {
        return true;
      }
      return false;
    },
    allowedInFreePlans: false,
  },
  {
    name: "Bulk auto signers",
    settingsView: SETTINGS_BULK_AUTO_SIGNERS,
    fullpath: "/settings/bulk-auto-signers",
    faStyle: "far",
    faIcon: "signature",
    readPermission: SETTINGS.MANAGE_AUTHENTICATIONS,
    showOption() {
      // Check if org has box esign flow
      const appFlag = localStorage.getItem("appFlag")
        ? JSON.parse(localStorage.getItem("appFlag"))
        : undefined;

      if (appFlag && appFlag.esign_type && appFlag.esign_type === "BOX") {
        return false;
      }
      return true;
    },
    allowedInFreePlans: false,
  },
  {
    name: "Blockchain settings",
    settingsView: SETTINGS_BLOCKCHAIN,
    fullpath: "/settings/blockchain",
    faStyle: "fab",
    faIcon: "ethereum",
    showOption: true,
  },
  {
    name: "Billing",
    settingsView: SETTINGS_BILLING,
    fullpath: "/settings/billing",
    faStyle: "far",
    faIcon: "badge-dollar",
    showOption: true,
    allowedInFreePlans: true,
  },
  {
    name: "Users",
    settingsView: SETTINGS_TEAMMATES,
    fullpath: "/settings/teammates",
    faStyle: "far",
    faIcon: "users",
    readPermission: SETTINGS.MANAGE_TEAMMATES,
    showOption: true,
    allowedInFreePlans: false,
  },
  // {
  //   name: "Roles",
  //   settingsView: SETTINGS_ROLES,
  //   fullpath: "/settings/roles",
  //   faStyle: "far",
  //   faIcon: "user-tag",
  //   readPermission: SETTINGS.MANAGE_ROLES,
  // },
  {
    name: "Integrations",
    settingsView: SETTINGS_INTEGRATIONS,
    fullpath: "/settings/integrations",
    faStyle: "far",
    faIcon: "exchange-alt",
    readPermission: SETTINGS.CONFIGURE_INTEGRATIONS,
    showOption: true,
    // temp key to hide this item based on plan
    hiddenUnderPlans: TRIAL_AND_TRIAL_EXPIRED_PLANS,
    allowedInFreePlans: false,
  },
  {
    name: "Authentication",
    settingsView: SETTINGS_AUTHENTICATION,
    fullpath: "/settings/authentication",
    faStyle: "far",
    faIcon: "shield-alt",
    readPermission: SETTINGS.MANAGE_AUTHENTICATIONS,
    showOption: true,
    allowedInFreePlans: false,
  },
  {
    name: "Revv API",
    settingsView: SETTINGS_REVV_OAUTH,
    fullpath: "/settings/revv-api",
    faStyle: "far",
    faIcon: "key",
    showOption: true,
    // temp key to hide this item based on plan
    // hiddenUnderPlans: [],
    hiddenUnderPlans: TRIAL_AND_TRIAL_EXPIRED_PLANS,
    allowedInFreePlans: false,
  },
];

export const SETTINGS_DEFAULT_VIEW_URL = SETTINGS_VIEWS[0].settingsView;

export const CRM_TYPES = {
  OAUTH: "OAUTH",
  USERID: "USERID",
  ESIGN: "ESIGN",
  ZAPIER: "ZAPIER",
  STRIPE: "STRIPE",
};

// for CRM url parameter
// ex: /settings/integrations/salesforce
export const CRM_URL_PARAMS = {
  SALESFORCE: "salesforce",
  ZOHO: "zoho",
  DOCUSIGN: "docusign",
  ZAPIER: "zapier",
  STRIPE: "stripe",
  BOX: "box",
};

export const CRM_NAMES = {
  SALESFORCE: "Salesforce",
  ZOHO: "Zoho CRM",
  DOCUSIGN: "Docusign",
  ZAPIER: "Zapier",
  STRIPE: "Stripe",
  BOX: "Box",
};

export const CRM_SHORT_NAMES = {
  SALESFORCE: "SF",
  ZOHO: "ZO",
  DOCUSIGN: "DS",
  ZAPIER: "ZA",
  STRIPE: "SE",
  BOX: "BOX",
};

// crm config mappings related all constants
export const CRM_LOGOS_MAPPING = {
  [CRM_URL_PARAMS.SALESFORCE]: SF_LOGO,
  [CRM_URL_PARAMS.ZOHO]: ZOHO_LOGO,
  [CRM_URL_PARAMS.DOCUSIGN]: DOCSIGN_LOGO,
  [CRM_URL_PARAMS.ZAPIER]: ZAPIER_LOGO,
  [CRM_URL_PARAMS.STRIPE]: STRIPE_LOGO,
  // [CRM_URL_PARAMS.BOX]: BAMBOO_LOGO,
};

export const CRM_NAMES_MAPPING = {
  [CRM_URL_PARAMS.SALESFORCE]: CRM_NAMES.SALESFORCE,
  [CRM_URL_PARAMS.ZOHO]: CRM_NAMES.ZOHO,
  [CRM_URL_PARAMS.DOCUSIGN]: CRM_NAMES.DOCUSIGN,
  [CRM_URL_PARAMS.ZAPIER]: CRM_NAMES.ZAPIER,
  [CRM_URL_PARAMS.STRIPE]: CRM_NAMES.STRIPE,
  [CRM_URL_PARAMS.BOX]: CRM_NAMES.BOX,
};

export const CRM_SHORT_NAMES_MAPPING = {
  [CRM_URL_PARAMS.SALESFORCE]: CRM_SHORT_NAMES.SALESFORCE,
  [CRM_URL_PARAMS.BOX]: CRM_SHORT_NAMES.BOX,
  [CRM_URL_PARAMS.ZOHO]: CRM_SHORT_NAMES.ZOHO,
  [CRM_URL_PARAMS.DOCUSIGN]: CRM_SHORT_NAMES.DOCUSIGN,
};

export const CRM_TYPES_MAPPING = {
  [CRM_URL_PARAMS.SALESFORCE]: CRM_TYPES.OAUTH,
  [CRM_URL_PARAMS.ZOHO]: CRM_TYPES.OAUTH,
  [CRM_URL_PARAMS.BOX]: CRM_TYPES.OAUTH,
  [CRM_URL_PARAMS.DOCUSIGN]: CRM_TYPES.ESIGN,
  [CRM_URL_PARAMS.ZAPIER]: CRM_TYPES.ZAPIER,
  [CRM_URL_PARAMS.STRIPE]: CRM_TYPES.STRIPE,
};

export const CRM_INTEGRATIONS = [
  {
    name: CRM_NAMES[CRM_URL_PARAMS.SALESFORCE],
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.SALESFORCE],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.SALESFORCE}`,
    logopath: SF_LOGO,
    featureName: FEATURES_NAME.INTG_SALESFORCE_STANDARD,
  },
  {
    name: CRM_NAMES[CRM_URL_PARAMS.ZOHO],
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.ZOHO],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.ZOHO}`,
    logopath: ZOHO_LOGO,
    featureName: FEATURES_NAME.INTG_ZOHO,
  },
  {
    name: CRM_NAMES[CRM_URL_PARAMS.ZAPIER],
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.ZAPIER],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.ZAPIER}`,
    logopath: ZAPIER_LOGO,
    featureName: FEATURES_NAME.INTG_ZAPIER,
  },
  {
    name: CRM_NAMES[CRM_URL_PARAMS.STRIPE],
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.STRIPE],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.STRIPE}`,
    logopath: STRIPE_LOGO,
    featureName: FEATURES_NAME.INTG_STRIPE,
  },
  {
    name: CRM_NAMES[CRM_URL_PARAMS.BOX],
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.BOX],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.BOX}`,
    logopath: BAMBOO_LOGO,
    featureName: FEATURES_NAME.INTG_BOX,
  },
];

// Teammates Settings
export const USER_GROUPS = ["Deal Desk", "Legal", "Sales"];

// INTEGRATION SETTINGS PAGE

// ! Do not change the order
export const UPCOMING_INTEGRATIONS = [
  SLACK_LOGO,
  BRAINTREE_LOGO,
  ZENDESK_LOGO,
  ADP_LOGO,
  BAMBOO_LOGO,
  BIGIN_LOGO,
  FRESHBOOKS_LOGO,
  FRESHSALES_LOGO,
  HUBSPOT_LOGO,
  NAMELY_LOGO,
  QUICKBOOK_LOGO,
  XERO_LOGO,
  SAGEINTACCT_LOGO,
  NETSUITE_LOGO,
  PIPEDRIVE_LOGO,
  DOCSIGN_LOGO,
];
